import React from "react";
import { Message } from "components/generic/layout";
import { SignInLayout } from "components/common/auth";

export default () => (
  <SignInLayout>
    <Message
      title="The invitation link is invalid, please enter a valid link!"
      subtext={
        <span>
          Learn more about The Lobby <a href="https://thelobby.io"> here</a>
        </span>
      }
    />
  </SignInLayout>
);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/InvalidInvitationLink/index.js